import {
  baseDashboard, baseMyJourneys, baseTasks, companyIntegrations, SidebarSection,
} from "./shared";

const itAdminSidebarItems: SidebarSection[] = [
  { id: "top", items: [baseDashboard, baseTasks, baseMyJourneys] },
  { id: "company", header: "Company", items: [companyIntegrations] },
];

export default itAdminSidebarItems;
